export const Entitlements = {
    IpRestrictions: 'Platform.IpRestrictions',
    CustomerManagedKey: 'Platform.CustomerManagedKey',
};
